import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthMe } from "../hooks/useAuthMe";
import { isPostLoginGraceActive } from "../auth/session/authSession.grace";
import {
  APPLICATION_NOT_ASSIGNED_PATH,
  isAuthCallbackPath,
} from "../auth/session/authSession.service";
import {
  clearLoginSelection,
  userHasApplicationAccess,
} from "../utils/matchesAssignedApplicationOrigin";
import { readCachedSessionUser } from "../auth/session/authSession.storage";

/**
 * Redirects authenticated users without access to the current application origin.
 */
export const RequireAssignedApplication: React.FC = () => {
  const { data: authUser } = useAuthMe();

  if (isAuthCallbackPath()) {
    return <Outlet />;
  }

  if (typeof window !== "undefined") {
    const pathname = window.location.pathname;
    if (
      pathname === APPLICATION_NOT_ASSIGNED_PATH ||
      pathname.endsWith(APPLICATION_NOT_ASSIGNED_PATH)
    ) {
      return <Outlet />;
    }
  }

  if (isPostLoginGraceActive()) {
    return <Outlet />;
  }

  const sessionUser = authUser ?? readCachedSessionUser();
  if (!sessionUser) {
    return <Outlet />;
  }

  if (!userHasApplicationAccess(sessionUser)) {
    return <Navigate to={APPLICATION_NOT_ASSIGNED_PATH} replace />;
  }

  clearLoginSelection();

  return <Outlet />;
};

export default RequireAssignedApplication;
